/************************************
 * Main navigation
 ***********************************/
$(function () {
  // Define media query breakpoint (adjust as needed)
  const MOBILE_BREAKPOINT = 991; // or match your CSS breakpoint
  let isMobileView = $(window).width() < MOBILE_BREAKPOINT;

  // Function to toggle burger icons
  function toggleBurgerIcons($burger, isActive) {
    if (isActive) {
      // Show close icon, hide menu icon
      $burger.find(".icon-lines").addClass("d-none");
      $burger.find(".icon-close").removeClass("d-none");
      $(".header").addClass("header-bg-fix");
      // Prevent body scrolling when mobile menu is open
      if (isMobileView) {
        $("body").css("overflow-y", "hidden");
      }
    } else {
      // Show menu icon, hide close icon
      $burger.find(".icon-lines").removeClass("d-none");
      $burger.find(".icon-close").addClass("d-none");
      setTimeout(function () {
        $(".header").removeClass("header-bg-fix");
      }, 200);
      // Restore body scrolling when mobile menu is closed
      if (isMobileView) {
        $("body").css("overflow-y", "");
      }
    }
  }

  // Function to check if we're in mobile view
  function checkViewport() {
    const newIsMobile = $(window).width() < MOBILE_BREAKPOINT;

    if (isMobileView !== newIsMobile) {
      isMobileView = newIsMobile;

      // If switching to desktop view, remove inline styles and reset burger
      if (!isMobileView) {
        // Remove inline display styles from main-nav
        $(".main-nav").removeAttr("style");

        // Restore body scrolling when switching to desktop
        $("body").css("overflow-y", "");

        // Reset burger button and icons
        $(".js-burger").removeClass("active");
        toggleBurgerIcons($(".js-burger"), false);

        // Close all open submenus
        $(".has-submenu.open").removeClass("open");
        $(".sub-nav").removeAttr("style");
      } else {
        // If switching to mobile view, hide main-nav if burger is not active
        if (!$(".js-burger").hasClass("active")) {
          $(".main-nav").hide();
          // Ensure body scrolling is normal when mobile view but menu closed
          $("body").css("overflow-y", "");
        } else {
          // If burger is active when switching to mobile, prevent body scrolling
          $("body").css("overflow-y", "hidden");
        }
      }
    }
  }

  // Initial check
  checkViewport();

  // Handle window resize
  $(window).on("resize", function () {
    // Debounce the resize event for better performance
    clearTimeout(window.resizeTimer);
    window.resizeTimer = setTimeout(checkViewport, 250);
  });

  // Burger menu toggle - only works on mobile
  if ($(".js-burger").length) {
    $(".js-burger").on("click", function (e) {
      // Only execute in mobile view
      if (!isMobileView) return;

      e.preventDefault();
      e.stopPropagation();

      const $this = $(this);
      const isOpening = !$this.hasClass("active");

      // Toggle burger active state
      $this.toggleClass("active");

      // Toggle burger icons
      toggleBurgerIcons($this, $this.hasClass("active"));

      // Toggle main-nav visibility
      $(".main-nav").stop(true, true).slideToggle("fast");

      // Close any open submenus when closing burger menu
      if (!isOpening) {
        $(".has-submenu.open").removeClass("open").find(".sub-nav").slideUp("fast");
      }
    });
  }

  // Toggle submenu on arrow click
  if ($(".header .js-down-arrow").length) {
    $(".header .js-down-arrow").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $parentItem = $(this).closest(".has-submenu");

      // Close all other open menus except current
      $(".header .has-submenu.open").not($parentItem).removeClass("open").find(".sub-nav").slideUp("fast");

      // Toggle current menu
      $parentItem.toggleClass("open");
      $parentItem.find(".sub-nav").slideToggle("fast");
    });
  }

  // Close menus when clicking outside
  $(document).on("click", function (e) {
    const $target = $(e.target);

    // If clicking outside navigation area
    if (!$target.closest(".main-nav").length && !$target.hasClass("js-burger") && !$target.closest(".js-burger").length) {
      // Close all open submenus
      if ($(".has-submenu.open").length) {
        $(".has-submenu.open").removeClass("open").find(".sub-nav").slideUp("fast");
      }

      // Close mobile menu if open (only in mobile view)
      if (isMobileView && $(".js-burger").length && $(".js-burger").hasClass("active")) {
        const $burger = $(".js-burger");
        $burger.removeClass("active");
        toggleBurgerIcons($burger, false);
        $(".main-nav").slideUp("fast");
        // Restore body scrolling when mobile menu is closed via outside click
        $("body").css("overflow-y", "");
      }
    }
  });

  // Close with Escape key
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      // Close all open submenus
      if ($(".has-submenu.open").length) {
        $(".has-submenu.open").removeClass("open").find(".sub-nav").slideUp("fast");
      }

      // Close mobile menu if open (only in mobile view)
      if (isMobileView && $(".js-burger").length && $(".js-burger").hasClass("active")) {
        const $burger = $(".js-burger");
        $burger.removeClass("active");
        toggleBurgerIcons($burger, false);
        $(".main-nav").slideUp("fast");
        // Restore body scrolling when mobile menu is closed via Escape key
        $("body").css("overflow-y", "");
      }
    }
  });

  // Optional: Click on main nav link to toggle
  if ($(".header .main-nav__item-link").length) {
    $(".header .main-nav__item-link").on("click", function (e) {
      if ($(this).closest(".has-submenu").length) {
        e.preventDefault();
        $(this).siblings(".js-down-arrow").trigger("click");
      }
    });
  }
});

/************************************
 * Custom Popup
 ***********************************/
function initSearchPopup() {
  const $body = $("body");
  const $backdrop = $('<div class="popup-backdrop"></div>');

  $(".js-icon-search").on("click", function (e) {
    $("#popup").addClass("open");
    $body.addClass("popup-open");
    $body.append($backdrop);
  });

  $(".js-popup__close").on("click", function (e) {
    $("#popup").removeClass("open");
    $body.removeClass("popup-open");
    $backdrop.remove();
  });

  // Optional: Close on backdrop click
  $(document).on("click", ".popup-backdrop", function () {
    $("#popup").removeClass("open");
    $body.removeClass("popup-open");
    $(this).remove();
  });
}
document.addEventListener("DOMContentLoaded", initSearchPopup);

/************************************
 * Footer links
 ***********************************/
function initFooterLinks() {
  if ($(".js-links").length) {
    // Click handler
    $(".js-links").on("click", function (e) {
      if ($(window).width() < 768) {
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this);
        var $links = $this.closest(".column").find("ul.links");
        var $plus = $this.find(".plus");
        var $close = $this.find(".close");

        // Toggle links and icons
        if ($links.is(":visible")) {
          $links.slideUp(200, function () {
            $(this).css("display", "none");
            $plus.toggleClass("d-none");
            $close.toggleClass("d-none");
          });
        } else {
          $links
            .css("display", "flex")
            .hide()
            .slideDown(200, function () {
              $(this).css("display", "flex");
              $plus.toggleClass("d-none");
              $close.toggleClass("d-none");
            });
        }
      }
    });

    // Resize handler
    $(window)
      .on("resize", function () {
        var windowWidth = $(window).width();

        if (windowWidth >= 768) {
          // Desktop: show all as flex, reset icons
          $("ul.links").css("display", "flex");
          $(".plus").removeClass("d-none");
          $(".close").addClass("d-none");
        } else {
          // Mobile: hide links, reset icons to plus
          $("ul.links").hide();
          $(".plus").removeClass("d-none");
          $(".close").addClass("d-none");
        }
      })
      .trigger("resize");
  }
}
document.addEventListener("DOMContentLoaded", initFooterLinks);

/************************************
 * Hero Slider
 ***********************************/
function initHeroSlider() {
  const heroSlider = $(".js-hero-slider");
  if (!heroSlider.length) return;

  heroSlider.owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: false,
    smartSpeed: 600,
    mouseDrag: false,
    animateIn: "fadeIn",
    animateOut: "fadeOut",
    navText: ['<span class="fa-solid fa-chevron-left"></span>', '<span class="fa-solid fa-chevron-right"></span>'],
    onInitialized: moveControlsIntoNav,
    onRefreshed: moveControlsIntoNav,
  });

  function moveControlsIntoNav(event) {
    const $carousel = $(event.target);
    const $nav = $carousel.find(".owl-nav");
    const $dots = $carousel.find(".owl-dots");
    const $prev = $nav.find(".owl-prev");
    const $next = $nav.find(".owl-next");

    // Remove existing inserts to avoid duplication
    $nav.find(".owl-dots").remove();
    $nav.find(".hero-slider-controls").remove();

    // Move dots after prev
    $dots.insertAfter($prev).addClass("within-nav");

    // Add play/pause button after next
    const $playPauseBtn = $(`
      <div class="hero-slider-controls">
        <button id="pause-slider" class="play-n-pause"><span class="fa-solid fa-pause"></span></button>
      </div>
    `);
    $playPauseBtn.insertBefore($prev);
    // Wrap .owl-nav in a container
    // Wrap .owl-nav in a container ONLY if not already wrapped
    if (!$nav.parent().hasClass("container")) {
      $nav.wrap('<div class="container position-relative"></div>');
    }

    let isPaused = false;

    $(".play-n-pause").on("click", function () {
      const $icon = $(this).find("span");

      if (isPaused) {
        $carousel.trigger("play.owl.autoplay");
        $icon.removeClass("fa-play").addClass("fa-pause");
      } else {
        $carousel.trigger("stop.owl.autoplay");
        $icon.removeClass("fa-pause").addClass("fa-play");
      }

      isPaused = !isPaused;
    });
  }
}
document.addEventListener("DOMContentLoaded", initHeroSlider);

/************************************
 * Brand logos Slider
 ***********************************/
function initBrandLogosSlider() {
  const brandLogosSlider = $(".js-brand-logos-slider");
  if (!brandLogosSlider.length) return;

  brandLogosSlider.owlCarousel({
    items: 5,
    loop: true,
    margin: 40,
    nav: false,
    dots: false,
    autoplay: true,
    rewind: true,
    slideTransition: "linear",
    autoplayTimeout: 3000,
    autoplayHoverPause: false,

    autoplaySpeed: 3000,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 2,
        margin: 20,
      },
      576: {
        items: 3,
        margin: 20,
      },
      768: {
        items: 3,
        margin: 20,
      },
      1024: {
        items: 5,
        margin: 40,
      },
    },
  });
}
document.addEventListener("DOMContentLoaded", initBrandLogosSlider);

/************************************
 * Features Slider
 ***********************************/
function initFeaturesSlider() {
  const featuresSlider = $(".js-features-slider");
  if (!featuresSlider.length) return;

  featuresSlider.owlCarousel({
    items: 3,
    loop: true,
    margin: 16,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1.2,
      },
      576: {
        items: 1.3,
      },
      768: {
        items: 2,
      },
      991: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  });
}
document.addEventListener("DOMContentLoaded", initFeaturesSlider);

/************************************
 * Testimonial Slider
 ***********************************/
function initTestimonialSlider() {
  const testimonialSlider = $(".js-testimonial-slider");
  if (!testimonialSlider.length) return;

  testimonialSlider.owlCarousel({
    items: 1,
    // loop: true,
    // margin: 0,
    // nav: false,
    // dots: true,
    // autoHeight: true,
    loop: true,
    margin: 0,
    nav: false,
    dots: true,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    smartSpeed: 2000,
    mouseDrag: true,
    animateIn: "fadeIn",
    animateOut: "",
  });
}
document.addEventListener("DOMContentLoaded", initTestimonialSlider);

/************************************
 * Chip button active inactive
 ***********************************/
function initChipButton() {
  const chipBtn = $(".chip");
  if (!chipBtn.length) return;

  // Toggle active class on click
  chipBtn.on("click", function () {
    chipBtn.removeClass("active");
    $(this).addClass("active");
  });
}

document.addEventListener("DOMContentLoaded", initChipButton);

/************************************
 * Chips scroll functionality x-axis
 ***********************************/
function initChipsScrollXaxis() {
  const chipsContainer = document.querySelector(".chips");

  if (!chipsContainer) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  // Mouse events for desktop
  chipsContainer.addEventListener("mousedown", (e) => {
    isDown = true;
    chipsContainer.classList.add("dragging");
    startX = e.pageX - chipsContainer.offsetLeft;
    scrollLeft = chipsContainer.scrollLeft;
  });

  chipsContainer.addEventListener("mouseleave", () => {
    isDown = false;
    chipsContainer.classList.remove("dragging");
  });

  chipsContainer.addEventListener("mouseup", () => {
    isDown = false;
    chipsContainer.classList.remove("dragging");
  });

  chipsContainer.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - chipsContainer.offsetLeft;
    const walk = (x - startX) * 2; // Scroll multiplier
    chipsContainer.scrollLeft = scrollLeft - walk;
  });

  // Touch events for mobile
  chipsContainer.addEventListener("touchstart", (e) => {
    isDown = true;
    chipsContainer.classList.add("dragging");
    startX = e.touches[0].pageX - chipsContainer.offsetLeft;
    scrollLeft = chipsContainer.scrollLeft;
  });

  chipsContainer.addEventListener("touchend", () => {
    isDown = false;
    chipsContainer.classList.remove("dragging");
  });

  chipsContainer.addEventListener("touchmove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.touches[0].pageX - chipsContainer.offsetLeft;
    const walk = (x - startX) * 2;
    chipsContainer.scrollLeft = scrollLeft - walk;
  });

  // Enable keyboard navigation
  chipsContainer.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") {
      chipsContainer.scrollLeft -= 100;
      e.preventDefault();
    } else if (e.key === "ArrowRight") {
      chipsContainer.scrollLeft += 100;
      e.preventDefault();
    }
  });

  // Make container focusable for keyboard navigation
  chipsContainer.setAttribute("tabindex", "0");
}
document.addEventListener("DOMContentLoaded", initChipsScrollXaxis);

/************************************
 * Brand filter
 ***********************************/
function initChipsFilter() {
  const chipsContainer = document.querySelector(".chips");
  const chips = document.querySelectorAll(".chip");
  const brandCards = document.querySelectorAll(".brand-card");

  if (!chipsContainer || chips.length === 0 || brandCards.length === 0) return;

  // Function to filter cards based on selected service
  function filterCards(selectedService) {
    // Remove active class from all chips
    chips.forEach((chip) => {
      // chip.classList.remove("active");
    });

    // Add active class to clicked chip
    const clickedChip = document.querySelector(`.chip[data-service="${selectedService}"]`);
    if (clickedChip) {
      clickedChip.classList.add("active");
    }

    // Filter logic
    brandCards.forEach((card) => {
      const cardServices = card.getAttribute("data-services");

      if (selectedService === "all") {
        // Show all cards
        card.classList.remove("hidden", "fading");
      } else if (cardServices) {
        // Split services by comma and trim whitespace
        const servicesArray = cardServices.split(",").map((service) => service.trim());

        // Check if card should be shown for selected service
        if (servicesArray.includes(selectedService)) {
          card.classList.remove("hidden", "fading");
        } else {
          card.classList.add("hidden", "fading");
        }
      } else {
        // If card has no data-services attribute, hide it
        card.classList.add("hidden", "fading");
      }
    });

    // Optional: Animate the transition
    setTimeout(() => {
      brandCards.forEach((card) => {
        if (card.classList.contains("fading")) {
          card.classList.add("hidden");
          card.classList.remove("fading");
        } else {
          card.classList.remove("fading");
        }
      });
    }, 300);
  }

  // Add click event to each chip
  chips.forEach((chip) => {
    chip.addEventListener("click", function (e) {
      e.preventDefault();
      const service = this.getAttribute("data-service");
      filterCards(service);

      // Optional: Update URL hash for bookmarking
      window.location.hash = `filter=${service}`;
    });
  });

  // Initialize based on active chip or URL hash
  function initializeFilter() {
    // Check for URL hash
    const hash = window.location.hash;
    const hashMatch = hash.match(/filter=([^&]+)/);

    if (hashMatch) {
      // Filter based on URL hash
      filterCards(hashMatch[1]);
    } else {
      // Check for already active chip
      const activeChip = document.querySelector(".chip.active");
      if (activeChip) {
        const service = activeChip.getAttribute("data-service");
        filterCards(service);
      } else {
        // Default to "all services"
        filterCards("all");
      }
    }
  }

  // Initialize on page load
  initializeFilter();

  // Optional: Listen for hash changes
  window.addEventListener("hashchange", function () {
    const hash = window.location.hash;
    const hashMatch = hash.match(/filter=([^&]+)/);
    if (hashMatch) {
      filterCards(hashMatch[1]);
    }
  });
}
document.addEventListener("DOMContentLoaded", initChipsFilter);

/************************************
 * Team Members Drag Scroll
 ***********************************/
function TeamMembersDragScroll() {
  // Only run on mobile devices
  if (window.innerWidth >= 768) return;

  // Get ALL team member lists
  const lists = document.querySelectorAll(".team-members__list");
  if (!lists.length) return;

  // Track dragging state for each list individually
  const dragStates = new Map();

  // Initialize each list
  lists.forEach((list, index) => {
    dragStates.set(list, { isDragging: false, startX: 0, scrollLeft: 0 });

    // Add grab cursor style
    list.style.cursor = "grab";

    // Mouse events
    list.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return; // Only left click

      const state = dragStates.get(list);
      state.isDragging = true;
      state.startX = e.pageX - list.offsetLeft;
      state.scrollLeft = list.scrollLeft;
      list.style.cursor = "grabbing";
      list.style.userSelect = "none";
    });

    list.addEventListener("mousemove", (e) => {
      const state = dragStates.get(list);
      if (!state.isDragging) return;

      e.preventDefault();
      const x = e.pageX - list.offsetLeft;
      const walk = (x - state.startX) * 2;
      list.scrollLeft = state.scrollLeft - walk;
    });

    const handleMouseEnd = () => {
      const state = dragStates.get(list);
      state.isDragging = false;
      list.style.cursor = "grab";
      list.style.userSelect = "auto";
    };

    list.addEventListener("mouseup", handleMouseEnd);
    list.addEventListener("mouseleave", handleMouseEnd);

    // Touch events for mobile
    list.addEventListener(
      "touchstart",
      (e) => {
        const state = dragStates.get(list);
        state.isDragging = true;
        state.startX = e.touches[0].pageX - list.offsetLeft;
        state.scrollLeft = list.scrollLeft;
      },
      { passive: true },
    );

    list.addEventListener(
      "touchmove",
      (e) => {
        const state = dragStates.get(list);
        if (!state.isDragging) return;

        const x = e.touches[0].pageX - list.offsetLeft;
        const walk = (x - state.startX) * 2;
        list.scrollLeft = state.scrollLeft - walk;
      },
      { passive: true },
    );

    list.addEventListener("touchend", () => {
      const state = dragStates.get(list);
      state.isDragging = false;
    });
  });

  // Prevent click events when dragging for ALL team member cards
  const allCards = document.querySelectorAll(".team-member-card");
  allCards.forEach((card) => {
    card.addEventListener("click", (e) => {
      // Find which list this card belongs to
      const list = card.closest(".team-members__list");
      if (list) {
        const state = dragStates.get(list);
        if (state && state.isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    });
  });
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", TeamMembersDragScroll);

// Re-initialize on window resize (for mobile/desktop switching)
window.addEventListener("resize", TeamMembersDragScroll);

/************************************
 * Locations Drag Scroll Mobile
 ***********************************/
function initLocationsDragScroll() {
  // Only run on mobile devices
  if (window.innerWidth >= 768) return;

  // Get ALL location lists
  const locationLists = document.querySelectorAll(".ct-locations");
  if (!locationLists.length) return;

  // Track dragging state for each list individually
  const dragStateMap = new Map();

  // Initialize each location list
  locationLists.forEach((locationList) => {
    // Initialize drag state for this list
    dragStateMap.set(locationList, {
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
    });

    // Add grab cursor style
    locationList.style.cursor = "grab";

    // Mouse event handlers
    const handleMouseDown = (event) => {
      if (event.button !== 0) return; // Only left click

      const dragState = dragStateMap.get(locationList);
      dragState.isDragging = true;
      dragState.startX = event.pageX - locationList.offsetLeft;
      dragState.scrollLeft = locationList.scrollLeft;
      locationList.style.cursor = "grabbing";
      locationList.style.userSelect = "none";
    };

    const handleMouseMove = (event) => {
      const dragState = dragStateMap.get(locationList);
      if (!dragState.isDragging) return;

      event.preventDefault();
      const currentX = event.pageX - locationList.offsetLeft;
      const dragDistance = (currentX - dragState.startX) * 2;
      locationList.scrollLeft = dragState.scrollLeft - dragDistance;
    };

    const handleDragEnd = () => {
      const dragState = dragStateMap.get(locationList);
      dragState.isDragging = false;
      locationList.style.cursor = "grab";
      locationList.style.userSelect = "auto";
    };

    // Add mouse event listeners
    locationList.addEventListener("mousedown", handleMouseDown);
    locationList.addEventListener("mousemove", handleMouseMove);
    locationList.addEventListener("mouseup", handleDragEnd);
    locationList.addEventListener("mouseleave", handleDragEnd);

    // Touch event handlers
    const handleTouchStart = (event) => {
      const dragState = dragStateMap.get(locationList);
      dragState.isDragging = true;
      dragState.startX = event.touches[0].pageX - locationList.offsetLeft;
      dragState.scrollLeft = locationList.scrollLeft;
    };

    const handleTouchMove = (event) => {
      const dragState = dragStateMap.get(locationList);
      if (!dragState.isDragging) return;

      const currentX = event.touches[0].pageX - locationList.offsetLeft;
      const dragDistance = (currentX - dragState.startX) * 2;
      locationList.scrollLeft = dragState.scrollLeft - dragDistance;
    };

    const handleTouchEnd = () => {
      const dragState = dragState.get(locationList);
      dragState.isDragging = false;
    };

    // Add touch event listeners
    locationList.addEventListener("touchstart", handleTouchStart, { passive: true });
    locationList.addEventListener("touchmove", handleTouchMove, { passive: true });
    locationList.addEventListener("touchend", handleTouchEnd);
  });

  // Prevent click events when dragging for location cards
  const locationCards = document.querySelectorAll(".ct-location");
  locationCards.forEach((locationCard) => {
    const handleCardClick = (event) => {
      const parentList = locationCard.closest(".ct-locations");
      if (parentList) {
        const dragState = dragStateMap.get(parentList);
        if (dragState && dragState.isDragging) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    };

    locationCard.addEventListener("click", handleCardClick);
  });
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", initLocationsDragScroll);

// Re-initialize on window resize (for mobile/desktop switching)
window.addEventListener("resize", initLocationsDragScroll);

/************************************
 * Toggle Map and Locations
 ***********************************/
function toggleMapLocationsList() {
  // Check if required elements exist
  const viewMapBtn = document.getElementById("view-map");
  const viewListBtn = document.getElementById("view-ct-locations");
  const mapDiv = document.getElementById("map");
  const listDiv = document.getElementById("ct-locations");

  // Exit if any required element is missing
  if (!viewMapBtn || !viewListBtn || !mapDiv || !listDiv) {
    console.warn("Some required elements for toggleMapList are missing");
    return;
  }

  // Function to show map and hide list
  function showMap() {
    mapDiv.classList.remove("d-none");
    listDiv.classList.add("d-none");
    viewMapBtn.classList.add("active");
    viewListBtn.classList.remove("active");
  }

  // Function to show list and hide map
  function showList() {
    listDiv.classList.remove("d-none");
    mapDiv.classList.add("d-none");
    viewListBtn.classList.add("active");
    viewMapBtn.classList.remove("active");
  }

  // Set initial state based on which button has 'active' class
  if (viewMapBtn.classList.contains("active")) {
    showMap();
  } else if (viewListBtn.classList.contains("active")) {
    showList();
  } else {
    // Default to showing map
    showMap();
  }

  // Add click event listeners
  viewMapBtn.addEventListener("click", showMap);
  viewListBtn.addEventListener("click", showList);
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", toggleMapLocationsList);

/************************************
 * Toggle Jobs List and Map View
 ***********************************/
function toggleJobsView() {
  // Check if required elements exist
  const viewListBtn = document.getElementById("view-list-jobs");
  const viewMapBtn = document.getElementById("view-jobs-map");
  const listDiv = document.getElementById("all-jobs");
  const mapDiv = document.getElementById("map");

  // Exit if any required element is missing
  if (!viewListBtn || !viewMapBtn || !listDiv || !mapDiv) {
    console.warn("Some required elements for toggleJobsView are missing");
    return;
  }

  // Function to show list and hide map
  function showList() {
    listDiv.classList.remove("d-none");
    mapDiv.classList.add("d-none");
    viewListBtn.classList.add("active");
    viewMapBtn.classList.remove("active");
  }

  // Function to show map and hide list
  function showMap() {
    mapDiv.classList.remove("d-none"); // Remove d-none to SHOW map
    listDiv.classList.add("d-none");
    viewMapBtn.classList.add("active");
    viewListBtn.classList.remove("active");
  }

  // Set initial state based on which button has 'active' class
  if (viewListBtn.classList.contains("active")) {
    showList();
  } else if (viewMapBtn.classList.contains("active")) {
    showMap();
  } else {
    // Default to showing list (since list button starts with 'active' class in your HTML)
    showList();
  }

  // Add click event listeners
  viewListBtn.addEventListener("click", showList);
  viewMapBtn.addEventListener("click", showMap);
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", toggleJobsView);

/************************************
 * Custom Select
 ***********************************/
function customSelectDropdown() {
  const selects = document.querySelectorAll(".form-select");

  if (selects.length === 0) return;

  selects.forEach((select) => {
    // Check if already converted
    if (select.closest(".custom-select")) return;

    // Wrap select in .custom-select
    const wrapper = document.createElement("div");
    wrapper.classList.add("custom-select");
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    // Prevent native dropdown
    select.addEventListener("mousedown", (e) => {
      e.preventDefault();
      select.focus();
    });

    // Create dropdown container
    const dropdown = document.createElement("div");
    dropdown.classList.add("custom-dropdown");
    wrapper.appendChild(dropdown);

    // Hide dropdown initially
    dropdown.style.opacity = "0";
    dropdown.style.visibility = "hidden";
    dropdown.style.transition = "opacity 0.25s ease, visibility 0.25s ease";

    let isOpen = false;

    // Create options inside dropdown
    const children = Array.from(select.children);

    children.forEach((child) => {
      // Handle <optgroup>
      if (child.tagName.toLowerCase() === "optgroup") {
        const groupWrapper = document.createElement("div");
        groupWrapper.classList.add("custom-dropdown__group");

        // Label
        const groupLabel = document.createElement("p");
        groupLabel.textContent = child.label;
        groupWrapper.appendChild(groupLabel);

        // Create options inside the group
        const groupOptions = Array.from(child.querySelectorAll("option"));

        groupOptions.forEach((option) => {
          const optionDiv = document.createElement("div");
          optionDiv.classList.add("custom-option", "body-small");
          optionDiv.textContent = option.textContent;
          optionDiv.dataset.value = option.value;

          if (option.selected) optionDiv.classList.add("selected");

          optionDiv.addEventListener("click", () => {
            select.value = option.value;
            dropdown.querySelectorAll(".custom-option").forEach((opt) => opt.classList.remove("selected"));
            optionDiv.classList.add("selected");
            select.dispatchEvent(new Event("change"));
            closeDropdown();
          });

          groupWrapper.appendChild(optionDiv);
        });

        dropdown.appendChild(groupWrapper);
        return;
      }

      // Handle normal <option>
      if (child.tagName.toLowerCase() === "option") {
        const option = child;
        const optionDiv = document.createElement("div");
        optionDiv.classList.add("custom-option", "body-small");
        optionDiv.textContent = option.textContent;
        optionDiv.dataset.value = option.value;

        if (option.selected) optionDiv.classList.add("selected");

        optionDiv.addEventListener("click", () => {
          select.value = option.value;
          dropdown.querySelectorAll(".custom-option").forEach((opt) => opt.classList.remove("selected"));
          optionDiv.classList.add("selected");
          select.dispatchEvent(new Event("change"));
          closeDropdown();
        });

        dropdown.appendChild(optionDiv);
      }
    });

    const openDropdown = () => {
      isOpen = true;
      dropdown.style.opacity = "1";
      dropdown.style.visibility = "visible";
    };

    const closeDropdown = () => {
      isOpen = false;
      dropdown.style.opacity = "0";
      dropdown.style.visibility = "hidden";
    };

    // Toggle dropdown on click
    select.addEventListener("click", (e) => {
      e.stopPropagation();
      isOpen ? closeDropdown() : openDropdown();
    });

    // Close when clicking outside
    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) {
        closeDropdown();
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", customSelectDropdown);

/************************************
 * Job Refiner toggle
 ***********************************/
function jobRefinerToggle() {
  const $jobFilterRefine = $("#job-filter__refine");
  const $collapseIcon = $jobFilterRefine.find(".collapse-icon");
  const $collapseCloseIcon = $jobFilterRefine.find(".collapse-close-icon");
  const $jobRefiner = $("#job-refiner");

  // Check if all necessary elements exist
  if ($jobFilterRefine.length === 0 || $collapseIcon.length === 0 || $collapseCloseIcon.length === 0 || $jobRefiner.length === 0) {
    console.error("One or more required elements not found");
    return;
  }

  // Initialize - ensure jobRefiner is hidden
  $jobRefiner.hide();

  // Add click event
  $jobFilterRefine.on("click", function () {
    // Toggle icons
    $collapseIcon.toggleClass("d-none");
    $collapseCloseIcon.toggleClass("d-none");

    // Slide toggle the job refiner
    $jobRefiner.slideToggle(300);
  });
}

document.addEventListener("DOMContentLoaded", jobRefinerToggle);

/************************************
 * Scroll Magic Animated cards
 ***********************************/
function initAnimatedCards() {
  // Check if window width is above 786px
  if (window.innerWidth <= 786) {
    return; // Exit function if width is 786px or less
  }

  //init
  var controller = new ScrollMagic.Controller();

  // Get all animated cards
  var cards = document.querySelectorAll('[id^="animated-vc-card-"]');
  var cardCount = cards.length;

  // Create scenes for all cards except the last one
  for (var i = 1; i <= cardCount; i++) {
    var cardId = "#animated-vc-card-" + i;

    // Check if this is the last card
    if (i === cardCount) {
      // Last card scene with special logic
      var lastCardScene = new ScrollMagic.Scene({
        triggerElement: cardId,
        triggerHook: 0.2,
        duration: 200,
      })
        .on("enter", function () {
          // Toggle d-none-force class on all cards except the last one
          for (var j = 1; j < cardCount; j++) {
            $("#animated-vc-card-" + j).toggleClass("d-none-force");
          }
        })
        .setPin(cardId)
        // .addIndicators({
        //   name: "Scene " + i,
        //   colorTrigger: "#000",
        //   indent: 200,
        //   colorStart: "#222",
        // })
        .addTo(controller);
    } else {
      // Regular card scene (pinned)
      var regularScene = new ScrollMagic.Scene({
        triggerElement: cardId,
        triggerHook: 0.2,
      })
        .setPin(cardId)
        // .addIndicators({
        //   name: "Scene " + i,
        //   colorTrigger: "#000",
        //   indent: 200,
        //   colorStart: "#222",
        // })
        .addTo(controller);

      // Add active class to container when first card enters
      if (i === 1) {
        regularScene.on("enter", function () {
          $(".animated-vc-cards").addClass("active");
        });
      }
    }
  }
}

// Add resize event listener to handle window resizing
function handleResize() {
  // Destroy existing ScrollMagic instances if any
  if (window.scrollMagicController) {
    window.scrollMagicController.destroy(true);
    window.scrollMagicController = null;
  }

  // Reinitialize if window width is above 786px
  if (window.innerWidth > 786) {
    initAnimatedCards();
  }
}

// Store controller globally to be able to destroy it
window.addEventListener("resize", debounce(handleResize, 250));

// Debounce function to improve performance
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

document.addEventListener("DOMContentLoaded", function () {
  // Initialize if window width is above 786px
  if (window.innerWidth > 786) {
    initAnimatedCards();
  }
});

/************************************
 *
 ***********************************/
